<template>
  <div class="zrqAreaMsgPage">
    <van-loading size="24px" vertical v-if="showNonePage"
      >加载中...</van-loading
    >
    <van-cell-group class="forestInput" v-if="!showNonePage">
      <van-field
        :value="baseData.gridName ? baseData.gridName : '无'"
        readonly
        label="责任区名称："
      />
      <van-field
        :value="getGridLevel(baseData.gridLevel)"
        readonly
        label="责任区级别："
      />
      <van-field
        :value="baseData.area ? baseData.area : '无'"
        readonly
        label="面积(公顷)："
      />

      <van-field
        v-for="(item, index) in baseData.gridPostList"
        :key="index"
        :value="item.userNames ? item.userNames : '无'"
        readonly
        rows="1"
        autosize
        type="textarea"
        :label="item.post + '：'"
      />
      <van-field
          v-for="(item, index) in baseData.regionPostList"
          :key="index"
          :value="item.userNames ? item.userNames : '无'"
          readonly
          rows="1"
          autosize
          type="textarea"
          :label="item.post + '：'"
        />
      <div class="area clearfix">
        <dl class="clearfix">
          <dt class="fl">所属政区：</dt>
          <dd class="areaName fr">
            <span>{{ baseData.regionName ? baseData.regionName : "无" }}</span>
            <!-- <span
              class="firstName"
              v-for="(item, index) in baseData.regionPostList"
              :key="index"
            >
              {{ item.post }}：<span>{{
                item.userNames ? item.userNames : "无"
              }}</span>
            </span> -->
          </dd>
        </dl>
        
      </div>
      
    </van-cell-group>
    <!-- <p class="subordinateTit" v-if="!showNonePage">下级政区</p>
    <div class="downAreaList" v-if="!showNonePage">
      <van-list
        v-model="loading"
        :finished="finished"
        @load="onLoad"
        :offset="100"
        finished-text="没有更多了"
        v-if="this.resultData.length > 0"
        class="subordinateArea"
      >
        <van-cell
          v-for="item in resultData"
          :key="item.id"
          class="childArea"
          @click="setMap(item)"
        >
          <dl>
            <dt>{{ item.regionName }}</dt>
            <dd
              class="firstName"
              v-for="(itemchild, childIndex) in item.regionPostList"
              :key="childIndex"
            >
              {{ itemchild.post }}：
              <span>{{
                itemchild.userNames ? itemchild.userNames : "无"
              }}</span>
            </dd>
          </dl>
        </van-cell>
      </van-list>
      <div class="nonePage" v-if="this.resultData.length < 1">
        <img :src="nonePng" alt />
        <p>暂无数据</p>
      </div>
    </div> -->
  </div>
</template>
<script>
/*eslint-disable*/
// import { getToken } from "@/utils/common";
import nonePng from "@/assets/none.png";
import { getDeviceType } from "@/common/getDeviceType/getDeviceType";
export default {
  name: "zrqAreaMsg",
  data() {
    return {
      showNonePage: true,
      nonePng: nonePng, //默认图片

      gridLevel: "", //等级
      baseData: {},
      resultData: [],
      backstagelists: [],
      page: 0,
      pageSize: 10,
      commentCount: 0,
      loading: false, //是否处于加载状态
      finished: false, //是否已加载完所有数据
      isLoading: false, //是否处于下拉刷新状态
      clientType: "", //手机类型
    };
  },
  props: {
    dataInfo: {
      type: Object,
      default: () => {
        {
          return {};
        }
      },
    },
  },
  mounted() {
    this.clientType = getDeviceType();

    this.$nextTick(function () {
      if (this.dataInfo.objid && this.dataInfo.type) {
        this.initPage();
      }
    });
  },
  methods: {
    initPage() {
      let _this = this;
      if (this.dataInfo.areaType == "zrq") {
        _this.$api.pubZrq
          .dutyMsg({
            objid: _this.dataInfo.objid,
            gridLevel: _this.dataInfo.level,
          })
          .then((res) => {
            if (res.code == "1" && res.data != null) {
              _this.showNonePage = false;
              console.log(res.data);
              _this.baseData = Object.assign({}, _this.baseData, res.data);
              // _this.downList();
            } else {
              console.log(res.msg);
              _this.$toast(res.msg);
            }
          })
          .catch((err) => {
            console.log(err);
          });
      } else {
        _this.$api.pubZrq
          .zqMsg({
            zqCode: _this.dataInfo.zqCode,
            regionLevel: _this.dataInfo.level,
          })
          .then((res) => {
            if (res.code == "1" && res.data != null) {
              _this.showNonePage = false;
              console.log(res.data);
              _this.baseData = Object.assign({}, _this.baseData, res.data);
              // _this.downList();
            } else {
              console.log(res.msg);
              _this.$toast(res.msg);
            }
          })
          .catch((err) => {
            console.log(err);
          });
      }
      // _this.$api.pubZrq
      //   .dutyMsg({
      //     objid: _this.dataInfo.objid,
      //     gridLevel: _this.dataInfo.level,
      //   })
      //   .then((res) => {
      //     if (res.code == "1" && res.data != null) {
      //       _this.showNonePage = false;
      //       console.log(res.data);
      //       _this.baseData = Object.assign({}, _this.baseData, res.data);
      //       // _this.downList();
      //     } else {
      //       console.log(res.msg);
      //       _this.$toast(res.msg);
      //     }
      //   })
      //   .catch((err) => {
      //     console.log(err);
      //   });
    },
    getLevel(type) {
      //获取责任区等级
      let grade = "";
      if (type == "geo_grid_sheng") {
        grade = "1";
      } else if (type == "geo_grid_shi") {
        grade = "2";
      } else if (type == "geo_grid_xian") {
        grade = "3";
      } else if (type == "geo_grid_xiang") {
        grade = "4";
      } else if (type == "geo_grid_cun") {
        grade = "5";
      } else {
        grade = "";
      }
      return grade;
    },
    getGridLevel(num) {
      let gradeName = "";
      if (num == "1") {
        gradeName = "省级";
      } else if (num == "2") {
        gradeName = "市级";
      } else if (num == "3") {
        gradeName = "县/区级";
      } else if (num == "4") {
        gradeName = "乡/镇级";
      } else if (num == "5") {
        gradeName = "村级";
      } else {
        gradeName = "无";
      }
      return gradeName;
    },
    downList() {
      let _this = this;
      if (_this.page != 0 && this.page * 10 >= parseInt(_this.commentCount)) {
        return;
      }
      _this.page += 1;
      _this.$api.pubZrq
        .nextRegionList({
          gridLevel: _this.dataInfo.level,
          objid: _this.dataInfo.objid,
          pageNum: _this.page,
          pageSize: _this.pageSize,
        })
        .then((res) => {
          if (res.code == "1") {
            if (res.data == null) {
              this.resultData = [];
              return;
            } else {
              let total = parseInt(res.data.total);
              _this.commentCount = total;
              _this.backstagelists = res.data.list;

              _this.viewLists();
              // 加载状态结束
              _this.loading = false;
              if (_this.page * 10 >= total) {
                _this.finished = true;
                console.log("加载完成");
              }
            }
          } else {
            _this.$toast(res.msg);
          }
        })
        .catch((err) => {
          this.refreshPage = true;
          console.log(err);
        });
    },
    viewLists() {
      this.resultData = this.resultData.concat(this.backstagelists);
    },

    onLoad() {
      // 异步更新数据
      setTimeout(() => {
        this.getTest();
      }, 500);
    },
  },
  watch: {
    dataInfo: {
      handler: function () {
        if (this.dataInfo.objid && this.dataInfo.type) {
          this.initPage();
        }
      },
      deep: true,
    },
  },
};
</script>
<style lang="less">
.zrqAreaMsgPage {
  width: 100%;
  height: 100%;
  padding-bottom: 45px;
  overflow-y: scroll;
  background-color: #fff;
  .forestInput {
    .van-cell {
      .van-field__label {
        color: #666;
        font-size: 14px;
      }

      .van-cell__value {
        .van-field__control {
          color: #333;
          font-size: 14px;
          text-align: right;
        }
      }

      .van-cell__title {
        width: 120px;
      }
    }

    .van-cell.lbStyle {
      .van-cell__title {
        width: 150px;
      }
    }

    .area {
      padding: 0 16px 10px 16px;
      dl {
        width: 100%;
        padding-top: 10px;
        dt {
          width: 30%;
          font-size: 14px;
          color: #666;
        }

        dd {
          max-width: 65%;
          font-size: 14px;

          color: #333;
          display: block;
          > span {
            text-align: right;
            display: block;
            > span {
              display: inline;
              color: #2d78f4;
            }
          }
        }
      }
    }
  }
  .subordinateTit {
    width: 100%;
    padding: 0 16px;
    height: 45px;
    line-height: 45px;
    font-size: 14px;
    color: #000;
    background-color: #f6f6f6;
    border-top: 1px solid #ebedf0;
    border-bottom: 1px solid #ebedf0;
  }
  .downAreaList {
    width: 100%;
    height: 300px;
    overflow-y: scroll;
    position: relative;
    padding-bottom: 50px;
    .subordinateArea {
      .childArea {
        padding: 0 16px;
        dl {
          width: 100%;
          min-height: 65px;
          position: relative;
          border-bottom: 1px solid #ebedf0;
          dt {
            font-size: 16px;
            color: #666;
          }

          dd {
            font-size: 14px;
            color: #333;
            display: block;
            span {
              color: #2d78f4;
            }
          }
        }
      }
    }
    .nonePage {
      width: 120px;
      height: 150px;

      position: absolute;
      left: 50%;
      margin-left: -60px;
      top: 50%;
      margin-top: -75px;

      img {
        display: block;
        max-width: 100px;
        max-height: 100px;
        margin: 0 auto;
      }

      p {
        margin-top: 10px;
        text-align: center;
        color: #5c5d5d;
        font-size: 16px;
      }
    }
  }
}
</style>